import PageNotFound from "@/components/PageNotFound";

function Page404() {
  return (
    <PageNotFound />
  );
}

export default Page404;
